var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "日期"
    }
  }, [[_c("time-date-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.formData,
      callback: function callback($$v) {
        _vm.formData = $$v;
      },
      expression: "formData"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "服务器列表"
    }
  }, [_c("server-list", {
    attrs: {
      isCache: ""
    },
    model: {
      value: _vm.searchInfo.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "server_id", $$v);
      },
      expression: "searchInfo.server_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: ""
    }
  }, [_c("el-radio-group", {
    attrs: {
      size: "mini"
    },
    model: {
      value: _vm.searchInfo.radio,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "radio", $$v);
      },
      expression: "searchInfo.radio"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "all"
    }
  }, [_vm._v("全部")]), _c("el-radio-button", {
    attrs: {
      label: "total"
    }
  }, [_vm._v("仅展示合计")]), _c("el-radio-button", {
    attrs: {
      label: "h5"
    }
  }, [_vm._v("仅展示H5")]), _c("el-radio-button", {
    attrs: {
      label: "wxgame"
    }
  }, [_vm._v("仅小游戏")])], 1)], 1), _c("el-form-item", {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c("el-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.searchEvent();
            }
          }
        }, [_vm._v(" 查询 ")])];
      },
      proxy: true
    }])
  })], 1), _c("span", {
    staticStyle: {
      color: "red"
    }
  }, [_vm._v("平台信息未接入，现全归属于H5")]), _vm.tableType == "all" ? _c("el-table", {
    attrs: {
      data: _vm.tableData,
      "span-method": _vm.handleSpanMethod,
      border: "",
      height: "1000"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "date_str",
      label: "日期"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "server_id",
      label: "服务器"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.serverList[scope.row.server_id]) + "(" + _vm._s(scope.row.server_id) + ") ")];
      }
    }], null, false, 93348336)
  }), _c("el-table-column", {
    attrs: {
      prop: "platform",
      label: "所属平台"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.platform == "h5" ? _c("span", [_vm._v("H5")]) : scope.row.platform == "wxgame" ? _c("span", [_vm._v("小游戏")]) : scope.row.platform == "total" ? _c("span", [_vm._v("合计")]) : _vm._e()];
      }
    }], null, false, 2437882329)
  }), _c("el-table-column", {
    attrs: {
      prop: "new_user",
      label: "新增用户"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "new_role",
      label: "创角数"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "vaild_role",
      label: "有效角色"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "new_role_pay",
      label: "首次付费人数"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_role",
      label: "付费人数"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_money",
      label: "付费金额"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_money",
      label: "付费率"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.new_user > 0 ? [_vm._v(_vm._s(_vm.cal.toDecimal2(scope.row.pay_role / scope.row.new_user * 100)) + " %")] : [_vm._v("0")]];
      }
    }], null, false, 4116403509)
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_money",
      label: "付费ARPU"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.pay_role > 0 ? [_vm._v(_vm._s(_vm.cal.toDecimal2(scope.row.pay_money / scope.row.pay_role)))] : [_vm._v(" 0")]];
      }
    }], null, false, 646202180)
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_money",
      label: "登录ARPU"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.new_user > 0 ? [_vm._v(_vm._s(_vm.cal.toDecimal2(scope.row.pay_money / scope.row.new_user)))] : [_vm._v(" 0")]];
      }
    }], null, false, 2540076292)
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_no1",
      label: "充值第一"
    }
  })], 1) : _vm._e(), _c("el-table", {
    attrs: {
      data: _vm.dataOne,
      border: true,
      height: "1000"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "date_str",
      label: "日期"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "server_id",
      label: "服务器"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.serverList[scope.row.server_id]) + "(" + _vm._s(scope.row.server_id) + ") ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "platform",
      label: "所属平台"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.platform == "h5" ? _c("span", [_vm._v("H5")]) : scope.row.platform == "wxgame" ? _c("span", [_vm._v("小游戏")]) : scope.row.platform == "total" ? _c("span", [_vm._v("合计")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "new_user",
      label: "新增用户"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "new_role",
      label: "创角数"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "vaild_role",
      label: "有效角色"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "new_role_pay",
      label: "首次付费人数"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_role",
      label: "付费人数"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_money",
      label: "付费金额"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_money",
      label: "付费率"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.new_user > 0 ? [_vm._v(_vm._s(_vm.cal.toDecimal2(scope.row.pay_role / scope.row.new_user * 100)) + " %")] : [_vm._v("0")]];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_money",
      label: "付费ARPU"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.pay_role > 0 ? [_vm._v(_vm._s(_vm.cal.toDecimal2(scope.row.pay_money / scope.row.pay_role)))] : [_vm._v(" 0")]];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_money",
      label: "登录ARPU"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.new_user > 0 ? [_vm._v(_vm._s(_vm.cal.toDecimal2(scope.row.pay_money / scope.row.new_user)))] : [_vm._v(" 0")]];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "pay_no1",
      label: "充值第一"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };